import React from 'react'
import BillingAddress from './BillingAddress';
import Typography from '@material-ui/core/Typography';
import CardContainer from './CardContainer';

const PaymentMethodPage =  ({ viewerObj, connectedStripeId }) => {
  if(!connectedStripeId) return null;

  return (
    <>
      <Typography variant="h4">Saved Card</Typography>
      {/* { connectedStripeId && 
        <BillingAddress 
          customerId={viewerObj.stripeId} 
          connectedStripeId={connectedStripeId}/>
      } */}

      {
        connectedStripeId && 
        <CardContainer 
          customerId={viewerObj.stripeId}
          connectedStripeId={connectedStripeId}/>
      }
    </>
  )

}

export default PaymentMethodPage